import type { UseRiveOptions } from "@rive-app/react-webgl2";

/**
 * WebGL2 renders at CSS pixels and upscales soft on retina without these:
 * `useDevicePixelRatio` renders at native resolution, and
 * `shouldResizeCanvasToContainer` keeps the canvas sized to its element box.
 * Shared by every direct `@rive-app/react-webgl2` `useRive` call in this
 * package (the standalone WebGL2 player and the carousel's WebGL2 slide) so
 * the retina/sizing fix only has to be made in one place.
 */
export const RIVE_WEBGL2_OPTIONS: Partial<UseRiveOptions> = {
  useDevicePixelRatio: true,
  shouldResizeCanvasToContainer: true,
};
